module.exports = __webpack_public_path__ + "static/ICR-Jus.3f534539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ICR-Jus.jpg
// module id = 459
// module chunks = 35783957827783